import React, { useContext } from 'react';
import ContentBox from 'Components/common/ContentBox/ContentBox';
import { AppContext } from 'App.context';
import JoditEditor from 'jodit-react';
import SaveButton from 'Components/common/SaveButton/SaveButton';
import styles from '../DefaultInfoTexts.styles';
import Colors from 'constants/Colors';
import AppButton from 'Components/common/Forms/AppButton/AppButton';
import { EyeFilled } from '@ant-design/icons';

export default function EndCheckinText({ state, actions }) {
  const {
    appActions: { translate },
  } = useContext(AppContext);

  const config = {
    placeholder: '',
    height: 300,
    toolbarAdaptive: false,
    removeButtons: ['fullsize', 'print', 'dots', 'copyformat', 'image'],
    showCharsCounter: false,
    showWordsCounter: false,
    cleanHTML: { fillEmptyParagraph: false },
  };

  return (
    <>
      <ContentBox noPadding title={translate('informationTexts.endCheckin')}>
        <JoditEditor
          value={state.endCheckinText || ''}
          config={config}
          onBlur={val => actions.handleEditorChange(val, 'endCheckinText')}
        />
        <div style={styles.previewButton}>
          <AppButton
            secondary
            //action={} no action needed
            text={translate('legalDocuments.previewBtn')}
            icon={<EyeFilled style={{ color: '#708393' }} />}
            style={{
              alignSelf: 'flex-end',
            }}
          />
        </div>
        <div style={styles.saveButtonContainer}>
          <SaveButton
            action={applyToAll =>
              actions.onSavePressed('end-checkin', state.endCheckinText, applyToAll)
            }
            text={translate('save')}
          />
        </div>
      </ContentBox>

      <ContentBox noPadding title={translate('legalDocuments.preview')}>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            height: '30vh',
            color: Colors.darkText,
          }}
        >
          <div dangerouslySetInnerHTML={{ __html: state.endCheckinText }} />
        </div>
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            marginTop: '2rem',
          }}
        >
          <button
            style={{
              backgroundColor: '#5d5d5d',
              color: '#fff',
              fontWeight: 'bold',
              padding: '1rem 3rem',
              border: 'none',
              borderRadius: '2rem',
              width: '80%',
              maxWidth: '400px',
              fontSize: '1rem',
              cursor: 'pointer',
            }}
          >
            {translate('informationTexts.continueButton')}
          </button>
        </div>
      </ContentBox>
    </>
  );
}
